import { render } from "./EcoScoreBadge.vue?vue&type=template&id=705dade5&scoped=true"
import script from "./EcoScoreBadge.vue?vue&type=script&lang=js"
export * from "./EcoScoreBadge.vue?vue&type=script&lang=js"

import "./EcoScoreBadge.vue?vue&type=style&index=0&id=705dade5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705dade5"]])

export default __exports__